import logger from '../utils/rbmc.logger';
// Info about callback: https://www.simoahava.com/gtm-tips/use-eventtimeout-eventcallback/

const trackingProductTile = {
    trackProductClick(evt) {

        if ('google_tag_manager' in window) {
            evt.preventDefault();
            evt.stopPropagation();
            const trackingData = evt.currentTarget.dataset;

            dataLayer.push({
                'event':     'EECproductClick',
                'ecommerce': {
                    'click': {
                        'actionField': {
                            'list': trackingData.listingType
                        },
                        'products':    [{
                            'name':     trackingData.name,
                            'id':       trackingData.id,
                            'price':    trackingData.price,
                            'brand':    trackingData.brand,
                            'category': trackingData.category,
                            'list':     trackingData.listingType,
                            'position': parseInt(trackingData.position, 10)
                        }]
                    }
                },
                'eventCallback': function () {
                    document.location = trackingData.eventCallback
                                },
                'eventTimeout':  2000
            });

            dataLayer.push({
                'event': 'select_item',
                ecommerce:  {
                    items:[{
                        'item_name':      trackingData.name,
                        'item_id':        trackingData.id,
                        'price':          trackingData.price,
                        'currency':       trackingData.currencyCode,
                        'item_brand':     trackingData.brand,
                        'item_category':  trackingData.category,
                        'item_list_name': trackingData.listingType,
                        'item_list_id':   'list',
                        'index':          parseInt(trackingData.position, 10),
                        'quantity':       1
                    }]
                },
                'eventCallback': function () {
                    document.location = trackingData.eventCallback
                },
                'eventTimeout':  2000
            });
        } else {
            logger.debug('no GTM present');
        }
    },

    bindProductClick() {
        $(document.body).on('click', '.tile--track', (evt) => {
            this.trackProductClick(evt);
        });
    }
};

$(() => {
    trackingProductTile.bindProductClick();
});

export default trackingProductTile;
